export default __webpack_public_path__ + "static/Hack-Bold-2b5dfa15b1bb24a3f320a1b223c9e844.woff";